import { AUTH_TOKEN_EXPIRY_TIME } from './constants';

export const getExpiryTime = (): number =>
  Number(window.localStorage.getItem(AUTH_TOKEN_EXPIRY_TIME));

export const setExpiryTime = (value: number) => {
  window.localStorage.setItem(AUTH_TOKEN_EXPIRY_TIME, value.toString());
};

export const isExpiryTime = (authCheckTimeout: number) =>
  new Date().getTime() + authCheckTimeout > getExpiryTime();

export const deleteExpiryTime = () => {
  window.localStorage.removeItem(AUTH_TOKEN_EXPIRY_TIME);
};
